import request from '@/utils/request'
import { MessageBox, Message } from 'element-ui'

export default{
  namespaced: true,
  state: {
    teacherList: [],
    teacherTotal: 0,
    sonList: [],
    sonTotal: 0
  },
  actions: {
    // 教师管理模块
    async getTeacherList ({dispatch, commit}, params) {
      const res = await request.get('/hcp/teacherSpace/teacher/page', {params})
      commit('UPDATE_VALUE_STATES', {key: 'teacherList', data: res.list || []})
      commit('UPDATE_VALUE_STATES', {key: 'teacherTotal', data: res.total || 0})
    },
    isBanTeacher ({dispatch, commit}, payload) {
      const {form, params} = payload
      const text = form.accountStatus === 0 ? '禁用' : '启用'
      MessageBox.confirm(`确定要${text}教师【${form.teacherName}】吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        // 不要直接修改原始行对象，避免前端列表状态被乐观更新
        const reqForm = {
          ...form,
          accountStatus: form.accountStatus === 0 ? 1 : 0
        }
        await dispatch('updateTeacher', {form: reqForm, params})
      })
    },
    async updateTeacher ({dispatch, commit}, payload) {
      const {form, params, callback} = payload
      await request.post('/hcp/teacherSpace/teacher/update', {...form})
      callback && callback()
      Message.success(`操作成功`)
      dispatch('getTeacherList', {...params})
    },
    async addTeacher ({dispatch, commit}, payload) {
      const {form, params, callback} = payload
      await request.post('/hcp/teacherSpace/teacher/save', {...form})
      callback && callback()
      Message.success(`操作成功`)
      dispatch('getTeacherList', {...params})
    },
    // 子账号管理模块
    async getSonList ({dispatch, commit}, params) {
      const res = await request.get('/hcp/teacherSpace/distributorAccount/page', {params})
      commit('UPDATE_VALUE_STATES', {key: 'sonList', data: res.list || []})
      commit('UPDATE_VALUE_STATES', {key: 'sonTotal', data: res.total || 0})
    },
    isBanSon ({dispatch, commit}, payload) {
      const {form, params} = payload
      const isBan = form.status === 0 ? '禁用' : '启用'
      const text = form.status === 0 ? '将不能' : '可以继续'
      MessageBox.confirm(`确定要${isBan}该账号吗?${isBan}后，该账号${text}登录`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        form.status = form.status === 0 ? 1 : 0
        await dispatch('updateSon', {form, params})
      })
    },
    async updateSon ({dispatch, commit}, payload) {
      const {form, params, callback} = payload
      await request.post('/hcp/teacherSpace/distributorAccount/update', {...form})
      callback && callback()
      Message.success(`操作成功`)
      dispatch('getSonList', {...params})
    },
    async addSon ({dispatch, commit}, payload) {
      const {form, params, callback} = payload
      await request.post('/hcp/teacherSpace/distributorAccount/save', {...form})
      callback && callback()
      Message.success(`操作成功`)
      dispatch('getSonList', {...params})
    }
  },
  mutations: {
    UPDATE_VALUE_STATES (state, payload) {
      const {key, data} = payload
      state[key] = data
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/account.js